export const DOTS = "...";

export interface paginationControlsProps {
    totalCount: number;
    siblingCount?: number;
    currentPage: number;
    pageSize: number;
    className?: string;
    onPageChange: (page: number) => void;
}

export const range = (start: number, end: number) => {
    const length = end - start + 1;
    return Array.from({ length }, (_, idx) => idx + start);
};
